import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { VirtualListGalleryRowMobile } from 'reactApp/ui/Mobile/VirtualList/VirtualListGalleryRowMobile';
import { VirtualListFastscrollRow } from 'reactApp/ui/VirtualList/VirtualListFastscrollRow';

import { VirtualListGalleryRow } from './VirtualListGalleryRow.new';
import { VirtualListGridRow } from './VirtualListGridRow.new';
import { VirtualListRow } from './VirtualListRow.new';

export const listChildrenMap = {
    [EViewMode.gallery]: VirtualListGalleryRow,
    [EViewMode.fastscroll]: VirtualListFastscrollRow,
    [EViewMode.list]: VirtualListRow,
    [EViewMode.thumbs]: VirtualListGridRow,
    [EViewMode.galleryGrid3]: VirtualListGalleryRowMobile,
    [EViewMode.squares]: VirtualListGridRow,
    [EViewMode.squares180]: VirtualListGridRow,
};
